import React, { useState } from 'react';
import { CnDrawer } from '@cainiaofe/cn-ui';
import AiAssistantEntry from './components/ai-assistant-entry';
import AiAssistantCore from './components/ai-assistant-core';
import './index.scss';
const CnCpoTalentAiAssistant = () => {
    const [drawerVisible, setDrawerVisible] = useState(false);
    const [mode, setMode] = useState();
    return (React.createElement("div", { className: "ai-assistant-wrap" },
        !drawerVisible && (React.createElement(AiAssistantEntry, { handleClickEntry: (key) => {
                setMode(key);
                setDrawerVisible(true);
            } })),
        React.createElement(CnDrawer, { className: "ai-assistant-drawer", visible: drawerVisible, noCard: true, onClose: () => {
                setDrawerVisible(false);
            }, title: "\u83DC\u5C0F\u62DB", closeMode: "close" },
            React.createElement("div", { className: "ai-assistant-drawer-content" },
                React.createElement("div", { className: "ai-assistant-policy" },
                    "\u4F60\u597D\uFF0C\u6211\u662FAI\u673A\u5668\u4EBA\u3002\u60A8\u63D0\u4F9B\u7ED9\u804A\u5929\u673A\u5668\u4EBA\u7684\u4FE1\u606F\u5C06\u88AB\u6536\u96C6\u4EE5\u6539\u5584\u60A8\u7684\u4F53\u9A8C\u3002\u8BF7\u9605\u8BFB",
                    React.createElement("a", { href: "https://jobs.cainiao.com/recruit-notice", target: "_blank" }, "\u6211\u4EEC\u7684\u9690\u79C1\u653F\u7B56"),
                    "\u4EE5\u4E86\u89E3\u6211\u4EEC\u5982\u4F55\u5B58\u50A8\u548C\u4FDD\u62A4\u60A8\u7684\u6570\u636E\uFF0C\u4EE5\u4E0B\u5185\u5BB9\u7531AI\u751F\u6210\u3002"),
                React.createElement(AiAssistantCore, { mode: mode })))));
};
export default CnCpoTalentAiAssistant;
